import { Box, Button, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

function BookConsultation() {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                padding: 3,
                border: `2px solid ${theme.palette.divider}`,
                backgroundColor: theme.palette.background.paper,
                boxShadow: theme.shadows[2],
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: 4,
                gap: 3,
                marginTop: {md: 2}
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                    textAlign: { xs: 'center', md: 'left' },
                }}
            >
                Need A Nutrition Consultation?
            </Typography>

            <Button
                variant="contained"
                sx={{
                    padding: '10px 20px',
                    fontSize: '1rem',
                    textTransform: 'none',
                    borderRadius: 3,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                    },
                }}
                onClick={() => navigate('/book-appointment')}
            >
                Book an Appointment
            </Button>
        </Box>
    );
}

export default BookConsultation;
